import styled from '@emotion/styled';
import { desktopOnly, mobileOnly } from '../../utils/sharedStyles';

export const FooterMenuDiv = styled.div`
  display: flex;
  align-items: flex-start;

  @media (${desktopOnly}) {
    gap: 12px;
    flex-direction: row;
  }

  @media (${mobileOnly}) {
    flex-direction: column;
    align-self: stretch;
  }
`;

export const StyledHorizontalBar = styled.div`
  height: 1px;
  width: 100%;
  flex-shrink: 0;
  background: var(--podium-cds-color-border-tertiary);

  @media (${mobileOnly}) {
    display: flex;
  }

  @media (${desktopOnly}) {
    display: none;
  }
`;
